import { FC } from 'react';

import { FileIcon, TrashIcon } from '@dynamika-shared/ui/icons';
import { TruncatedText } from '@dynamika-shared/ui/TruncatedText/TruncatedText';

export type UploadRecipientsFileCardProps = {
  file: File;
  /** Omitted once the file has been sent — there is nothing left to detach. */
  onRemove?: () => void;
};

/**
 * The attached CSV, replacing the drop zone. `onRemove` absent hides the bin,
 * as during and after processing detaching would imply an undo.
 */
export const UploadRecipientsFileCard: FC<UploadRecipientsFileCardProps> = ({
  file,
  onRemove,
}) => (
  <div
    data-testid='upload-recipients-file'
    className='mb-2 flex items-center gap-1.5 rounded-[2.4rem] border-2 border-dodgerBlue bg-white px-2 py-2 shadow-[2px_12px_30px_0px_rgba(208,215,225,0.5)]'
  >
    <FileIcon className='h-5 w-5 shrink-0 text-pastelBlue' />

    <div className='min-w-0 flex-1'>
      <TruncatedText
        text={file.name}
        className='block max-w-[240px] text-1624 font-medium text-chineseBlack'
        truncate
        tooltip
      />

      <p className='text-1216 text-dimGray'>Selected for Upload</p>
    </div>

    {onRemove && (
      <TrashIcon
        data-testid='upload-recipients-clear-file'
        className='h-3 w-3 shrink-0 cursor-pointer text-pastelBlue'
        onClick={onRemove}
      />
    )}
  </div>
);
